let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eA0gK")).then(() => parcelRequire('5ws4u'));